<template>
  <div class="notices">
    <div class="notices-swiper">
      <div class="swiper-container notices-container">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="notice in notices"
            :key="notice.information_text"
          >
            <div class="notices-article">
              <div class="notices-article-body">
                <p class="notices-article-text">
                  {{ $domUtils.decode(notice.information_text) }}
                </p>
              </div>
              <div class="notices-article-footer">
                <time
                  :datetime="notice.start_date"
                  class="notices-article-date"
                >{{ notice.start_date | formatDate }}</time>
                <MenuLink
                  v-if="notice.link_url !== ''"
                  class="notices-article-link"
                  :url="notice.link_url | replaceBusinessId"
                  :external="notice.link_url | isExternalUrl"
                >詳しく見る</MenuLink>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-button-next notices-button-next"></div>
      <div class="swiper-button-prev notices-button-prev"></div>
    </div>
    <div class="swiper-pagination notices-pagination"></div>
  </div>
</template>

<script>
import Swiper, {Navigation, Pagination} from 'swiper'
import { formatDate } from '@/filters/format-date.js'
import { replaceBusinessId } from '@/utils/init-injected-html'

export default {
  props: {
    notices: {
      type: Array,
      required: true
    }
  },
  filters: {
    formatDate,
    replaceBusinessId,
    isExternalUrl: val => val.indexOf('http') === 0
  },
  methods: {
    initCarousel() {
      new Swiper('.notices-container', {
        modules: [Navigation, Pagination],
        spaceBetween: 10,
        centeredSlides: true,
        loop: false,
        navigation: {
          nextEl: '.notices-button-next',
          prevEl: '.notices-button-prev'
        },
        pagination: {
          el: '.notices-pagination',
          type: 'bullets',
          clickable: true
        }
      })
    }
  },
  watch: {
    notices: {
      handler() {
        this.$nextTick(() => {
          this.initCarousel()
        })
      },
      immediate: true
    }
  }
}
</script>
